import React from "react";
import { Stack, Title, Text } from "@mantine/core";
import PageContent from "../shared/PageContent/PageContent";
import PitchReviewPanel from "../RepManagement/PitchReviewPanel";

/**
 * ManagerPitchReviewsPage — two-panel pitch review UI.
 * Replaces the old chat-based pitch review with the new review panel.
 */
const ManagerPitchReviewsPage = () => {
  return (
    <PageContent>
      <Stack gap={4} mb="lg">
        <Title order={3}>Pitch Reviews</Title>
        <Text size="sm" c="dimmed">
          Review, score, and leave feedback on your reps&apos; pitch submissions
        </Text>
      </Stack>
      <PitchReviewPanel />
    </PageContent>
  );
};

export default ManagerPitchReviewsPage;
